let title = "Premium Content";
let learnUrls = {};

export default {
    title,
    learnUrls,
    legalEntityShort: "Seismic",
    legalEntityFull: "Seismic, Inc",
    privacyPolicyUrl: 'https://www.seismic.com/legal/policies/privacy-policy/',
    termsOfUseUrl: 'https://www.seismic.com/Terms/',
    infoEmail: 'seismic@upcontent.com',
    marketingSiteUrl: 'https://www.upcontent.com/seismic',
    hideSubscription: true,
    hideSupportApps:  false,
    hideShare: true,
    hideZapier: true,
    hideIntegrations: false,
    hideGalleries: true,
    hideContentTemplates: true,
    hideFeedLink: false,
}
